import React from 'react';
import { useIntl } from 'react-intl';
import { ClipStep } from './components/ClipStep';
import { StatusMessage } from './components/StatusMessage';
import { TripStep } from './components/TripStep';
import { UnitSelect } from './components/UnitSelect';
import { useRequestVideoFlow } from './hooks/useRequestVideoFlow';
import './style.scss';

const UnitHint = ({ flow }) => {
  const { initial } = flow;
  if (flow.unit) return null;
  if (initial.isLoading) return <StatusMessage id="requestVideo_unit_loading" />;
  if (initial.isError) return <StatusMessage id="requestVideo_unit_error" tone="error" onRetry={initial.refetch} />;
  if (initial.notFound) return <StatusMessage id="requestVideo_unit_notFound" tone="error" />;
  return <StatusMessage id="requestVideo_unit_empty" />;
};

// Isolated flow to request a clip: unit -> day -> trip -> 5-minute window -> clip range.
// State lives per instance; only the TanStack query cache is shared between instances.
export const RequestVideo = ({ initialCameraDeviceId, hideUnitSelector = false, onSubmitted, onCancel }) => {
  const { formatMessage } = useIntl();
  const flow = useRequestVideoFlow({ initialCameraDeviceId, hideUnitSelector, onSubmitted });

  // A successful request only shows the app's toast (see useCreateClipRequest); the flow stays as it was.
  return (
    <div className="request-video">
      <h3 className="request-video-title">{formatMessage({ id: 'requestVideo_title' })}</h3>
      {!hideUnitSelector && (
        <UnitSelect unit={flow.unit} unitList={flow.unitList} onSearch={flow.startSearch} onPick={flow.pickUnit} />
      )}
      <UnitHint flow={flow} />
      {flow.unit && <TripStep flow={flow} />}
      {flow.window && <ClipStep flow={flow} onCancel={onCancel} />}
    </div>
  );
};

export default RequestVideo;
